import z from 'zod';

export const TERMS_AND_CONDITIONS_FORM_SCHEMA = z.object({
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: 'Required field',
  }),
  termsAcceptedAt: z.coerce.date({
    required_error: 'Terms acceptance date is required',
    invalid_type_error: 'Invalid date',
  }),
  privacyAccepted: z.boolean().refine((val) => val === true, {
    message: 'Required field',
  }),
});
